.unit {
  display: flex;
  align-items: center;
  min-width: 0;

  label {
    padding: 0 7px;
  }
}
